angular.module('workflow.app')

.factory( 'Entity', ( Model ) ->

  class Entity extends Model

)